import { Component, Injectable, OnInit, OnDestroy, ViewChild, TemplateRef, ViewEncapsulation } from '@angular/core';
import { AuthenticationService, TestData, TokenPayload, UserType } from '../services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AlertPromise } from 'selenium-webdriver';
import { AdminService } from '../services/admin.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogConfig } from "@angular/material";
import { CreateAdminComponent } from '../createAdminUser/createAdmin.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';


@Component({
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  encapsulation: ViewEncapsulation.None
})
@Injectable()
export class AdminComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['S.No.', 'first_name', 'email', 'phone', 'Actions'];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("content") modalContent: TemplateRef<any>;
  searchKey: string;
  dataSource: MatTableDataSource<any>;
  result: string[];
  userAdmin: boolean;
  userSuperAdmin: boolean;
  isCustomStyleApplied: boolean = false;
  screenWidth: number | undefined;
  screenHeight: number | undefined;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  details: boolean;
  questionset: boolean;
  scheduletest: boolean;
  overall: boolean;
  evaluate: boolean;
  modalService: any;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;



  links = ['Super Admin', 'Admin', 'Test Scheduler', 'Test Taker'];
  admin_details: any;
  userEvaluator: boolean;


  // tslint:disable-next-line: max-line-length
  constructor(private auth: AuthenticationService, private modal: NgbModal, private router: Router, private dialog: MatDialog,
    private adminservice: AdminService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {

    this.simpletest();

    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }
  columns: string[];
  // tslint:disable-next-line: member-ordering
  email;
  user;
  fname;
  lname;
  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };



  credentials: TokenPayload = {
    id: '',
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    // confirmpassword: '',
    phone: '',
    type: ''
   
  };

  ngOnInit() {
    this.getAccess();
    this.columns = this.auth.getColumnsB();
    this.getScreenSize();
    this.applyStylesBasedOnResolution();
  }
  getScreenSize(): void {
    this.screenWidth = window.innerWidth;
     
    this.screenHeight = window.innerHeight;
    
  }

  applyStylesBasedOnResolution(): void {
    if (this.screenWidth && this.screenHeight) {
      
      if (this.screenWidth < 1366 && this.screenHeight <  641) {
        this.isCustomStyleApplied = true;
        
      
      }
     
    }
  }
  
  pickUser() {
    this.auth.isLoggedIn();
  }
  onSearchClear() {
    this.searchKey = "";
    this.applyFilter();
  }

  // getAccess(){
  //   this.user = sessionStorage.getItem('user');
  //   this.fname = sessionStorage.getItem('fname');

  //   this.lname = sessionStorage.getItem('lname');


  //   if (this.user === '2') {

  //     this.userAdmin = true;
  //     this.userSuperAdmin = false;
  //     this.userTestScheduler = true;
  //   } else if (this.user === '1') {

  //     this.userAdmin = true;
  //     this.userSuperAdmin = true;
  //     this.userTestScheduler = true;
  //   } else if (this.user === '3') {
  //     this.userAdmin = false;
  //     this.userSuperAdmin = false;
  //     this.userTestScheduler = true;
  //   }
  // }

  getAccess(){
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');


    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }

  applyFilter() {
    this.dataSource.filter = this.searchKey.trim().toLowerCase();
  }
  simpletest() {
    this.adminservice.admin(this.test).subscribe(
      (data) => {
        this.admin_details = data.results;


        this.user = sessionStorage.getItem('user');
        this.fname = sessionStorage.getItem('fname');

        this.lname = sessionStorage.getItem('lname');


        this.dataSource = new MatTableDataSource(this.admin_details);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;

          this.details = true;
          this.result = data.results;
          return this.result;
      },
      err => {
        console.error(err);
      }

    );
  }


  edit(user) {


    this.router.navigate(['/edit', user.id]);
  }

  onCreate() {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };


    //Open modal on pressing escape
    const modalRef = this.modal.open(this.modalContent, ngbModalOptions)
  }

  delete(user) {

    Swal.fire({
      title: 'Are you sure want to delete?',
      text: 'You will not be able to recover later!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.isConfirmed) {
        this.adminservice.delete(user).subscribe(
          (data) => {
            // alert(data.success);
            window.location.reload();
    
            return;
          });}
        else if (result.dismiss === Swal.DismissReason.cancel) {
  
        }
      })
  }

  OnAddAdmin(form: NgForm) {

    this.router.navigateByUrl('/createAdmin');
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

}
